import { render } from "./memberPerformanceModal2.vue?vue&type=template&id=b2ef2a2a&scoped=true&ts=true"
import script from "./memberPerformanceModal2.vue?vue&type=script&lang=ts"
export * from "./memberPerformanceModal2.vue?vue&type=script&lang=ts"

import "./memberPerformanceModal2.vue?vue&type=style&index=0&id=b2ef2a2a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2ef2a2a"]])

export default __exports__